__webpack_require__.p = "https://reports.core-artifacts.com/static/";